<div *ngIf="data; else loading">
    <donationCategory-short-details [donationCategory]="data"></donationCategory-short-details>
</div>

<ng-template #loading>
    <h1>
        <i style="color: gray" class="fa fa-refresh fa-spin"></i>
    </h1>
</ng-template>
